import { AttributeFormState } from '@idw-types/state/attribute-form-state';
import { SelectOption } from "@iddataweb/idw-common-ui/types";
import { FocusEvent, useMemo } from 'react';
import { FormikErrors } from 'formik';
import { getIDOptionsByAttributeType } from '@utils/id-options-util';
import { IDDisclaimerText } from './id-disclaimer-text';
import { IDSelectInput } from './id-select-input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from "@fortawesome/free-solid-svg-icons/faLock";
import { useSelector } from 'react-redux';
import { getLanguageContent } from '@redux/selectors/language-selectors';
import styles from "./id-selection-attribute.less";

type IDSelectionAttributeProps = {
    title: string;
    attribute: AttributeFormState;
    fieldName: string;
    fieldTouched: boolean;
    fieldError: string;
    fieldIsInvalid: boolean;
    fieldShouldBeHighlighted: boolean;
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void> | Promise<FormikErrors<any>>;
    setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void;
    onBlur: (event: FocusEvent<HTMLInputElement>) => void;
    onSetSubmitValue: (data: any) => void;
    isSubmitting: boolean;
};

export const IDSelectionAttribute = (props: IDSelectionAttributeProps) => {
    const {
        title,
        attribute,
        fieldName,
        fieldTouched,
        fieldError,
        fieldIsInvalid,
        fieldShouldBeHighlighted,
        setFieldValue,
        setFieldTouched,
        onBlur,
        onSetSubmitValue,
        isSubmitting
    } = props;

    const content = useSelector(getLanguageContent);

    const idOptions: Array<SelectOption & { id: string }> = useMemo(() => {
        return getIDOptionsByAttributeType(content, attribute.type).map(option => ({
            label: option.label, value: option.value, id: option.id
        }));
    }, [attribute.type, content]);

    return (
        <div className={styles.idSelectionAttribute}>
            <IDDisclaimerText idOptions={idOptions} attributeType={attribute.type} />
            <IDSelectInput
                title={title}
                idOptions={idOptions}
                attribute={attribute}
                fieldName={fieldName}
                fieldTouched={fieldTouched}
                fieldError={fieldError}
                fieldIsInvalid={fieldIsInvalid}
                fieldShouldBeHighlighted={fieldShouldBeHighlighted}
                onBlur={onBlur}
                setFieldTouched={setFieldTouched}
                setFieldValue={setFieldValue}
                onSetSubmitValue={onSetSubmitValue}
                isSubmitting={isSubmitting}
            />
            <div className={`${styles.privacyDisclaimer} privacy-disclaimer`}>
                <FontAwesomeIcon className={styles.lockIcon} icon={faLock} />
                {content.form.pickerInput.collectionDisclaimer}
            </div>
        </div>
    );
}
